// extracted by mini-css-extract-plugin
export default {"container":"Authorization_container__jeRrF","form":"Authorization_form__5D56+"};